import React, { Component, createElement, Fragment } from 'react';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions } from '@comall-backend-builder/core';
import { api } from '@comall-backend-builder/core/lib/services/api';
import { Radio as AntdRadio, Input as AntInput } from 'antd';
import { get, isNull } from 'lodash';
import './index.less';

export interface CategoryUnionProductTableProps {
    entities: { [index: string]: Entity };
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface CategoryUnionProductTableStates {
    currentType: 'PRODUCT' | 'ATTR' | null;
    refresh: string;
    style: string;
    sku: string;
}

class categoryUnionProductTable extends Component<
    CategoryUnionProductTableProps,
    CategoryUnionProductTableStates
> {
    constructor(props: CategoryUnionProductTableProps) {
        super(props);
        this.state = {
            currentType: null,
            refresh: 'true',
            style: '',
            sku: '',
        };
        this.onAddAttr = this.onAddAttr.bind(this);
        this.onAddProduct = this.onAddProduct.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
        this.onSwitchType = this.onSwitchType.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    onAddAttr(attribute: string, options: string[]) {
        const {
            entities: { categoryUnionProduct },
            params,
        } = this.props;
        categoryUnionProduct.add(
            {
                attr_code: attribute,
                attr_value_codes: options,
                union_type: 'ATTR',
            },
            {},
            {
                action: actions.searchAction(categoryUnionProduct, { ...params }),
            }
        );
    }

    getValue(attribute: string, options: string[]) {
        const {
            entities: { categoryUnionProduct },
        } = this.props;
        categoryUnionProduct.search({
            ...categoryUnionProduct.params,
            ...categoryUnionProduct.filters,
            style: this.state.style,
            sku: this.state.sku,
        });
    }

    onAddProduct(skus: string[]) {
        const {
            entities: { categoryUnionProduct },
            params,
        } = this.props;
        categoryUnionProduct.add(
            {
                sku_codes: skus,
                union_type: 'PRODUCT',
            },
            {},
            {
                action: actions.searchAction(categoryUnionProduct, { ...params }),
            }
        );
    }

    onDeleteBatch() {
        const {
            selectedRowKeys,
            entities: { categoryUnionProduct },
            params,
        } = this.props;

        categoryUnionProduct.delete(
            {
                ids: selectedRowKeys,
                type: 'batch',
            },
            {
                action: actions.searchAction(categoryUnionProduct, { ...params }),
            }
        );
    }

    onDeleteAll() {
        const {
            entities: { categoryUnionProduct },
            params,
        } = this.props;

        categoryUnionProduct.delete(
            {
                type: 'all',
            },
            {
                action: actions.searchAction(categoryUnionProduct, { ...params }),
            }
        );
    }

    componentWillMount() {
        this.loadType();
    }

    loadType() {
        const {
            params,
            entities: { categoryUnionProduct },
        } = this.props;
        return api
            .get(
                {},
                {
                    apiPath: `/display_category/${params.categoryId}/union_product/union_type`,
                }
            )
            .then((response: any) => {
                categoryUnionProduct.filtersChange({ unionType: response.unionType });
                categoryUnionProduct.pageChange({ page: 1, perPage: 10 });
                categoryUnionProduct.search({
                    ...categoryUnionProduct.params,
                    ...categoryUnionProduct.filters,
                    style: this.state.style,
                    sku: this.state.sku,
                });
                this.setState({
                    currentType: response.unionType,
                    refresh: response.refresh,
                });
            });
    }

    setType(type: 'PRODUCT' | 'ATTR') {
        const { params } = this.props;
        return api
            .put(
                { union_type: type },
                {
                    apiPath: `/display_category/${params.categoryId}/union_product/union_type`,
                }
            )
            .then((response: any) => {
                this.loadType();
            });
    }

    onSwitchType(e: any) {
        this.setType(e.target.value);
    }

    renderForm() {
        const { currentType } = this.state;
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <AntdRadio.Group
                    style={{ padding: '20px 0' }}
                    buttonStyle={'solid'}
                    value={currentType}
                    onChange={this.onSwitchType}
                >
                    关联方式：
                    <AntdRadio value="PRODUCT">按商品关联</AntdRadio>
                    <AntdRadio value="ATTR">按属性关联</AntdRadio>
                </AntdRadio.Group>
                {currentType === 'PRODUCT' ? (
                    <div className="input-box">
                        <div className="input-label">SKU:</div>
                        <AntInput
                            className="input-value"
                            value={this.state.sku}
                            onChange={(e) => {
                                let value = e.target.value;
                                this.setState({
                                    sku: value,
                                });
                            }}
                            placeholder="请输入"
                        />
                    </div>
                ) : (
                    ''
                )}
                {currentType === 'PRODUCT' ? (
                    <div className="input-box">
                        <div className="input-label">款号:</div>
                        <AntInput
                            className="input-value"
                            value={this.state.style}
                            onChange={(e) => {
                                let value = e.target.value;
                                this.setState({
                                    style: value,
                                });
                            }}
                            placeholder="请输入"
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }

    renderControllers() {
        const { currentType, refresh } = this.state;
        let selector;
        switch (currentType) {
            case 'ATTR':
                selector = {
                    component: 'AttributeOptionSelector',
                    onSelect: this.onAddAttr,
                    span: 2,
                };

                break;
            case 'PRODUCT':
                selector = {
                    component: 'ProductSelector',
                    onSelect: this.onAddProduct,
                    span: 2,
                };
                break;
        }
        let layoutProps;
        switch (currentType) {
            case 'ATTR':
                // if (refresh === 'true') {
                //     layoutProps = {
                //         component: 'GridLayout',
                //         items: [selector],
                //     };
                // }
                layoutProps = {
                    component: 'GridLayout',
                    items: [selector],
                };
                break;
            case 'PRODUCT':
                layoutProps = {
                    component: 'GridLayout',
                    items: [
                        selector,
                        {
                            component: 'Button',
                            text: '批量删除',
                            type: 'primary',
                            span: 2,
                            style: { marginBottom: '20px' },
                            onClick: this.onDeleteBatch,
                        },
                        {
                            component: 'Button',
                            text: '全部删除',
                            type: 'primary',
                            span: 2,
                            style: { marginBottom: '20px' },
                            onClick: this.onDeleteAll,
                        },
                        {
                            component: 'UploadButton',
                            buttons: {
                                text: '批量导入商品',
                                type: 'primary',
                            },
                            maxSize: 100 * 1024,
                            successTitle: '导入成功，请稍后查看',
                            failTitle: '导入失败了',
                            accept: '.xls,.xlsx,.csv',
                            action: '/templates/INSERT_CATEGORY_SKU',
                            className: 'upload-button',
                            span: 3,
                            style: { marginBottom: '20px' },
                        },
                        {
                            component: 'ExportButton',
                            text: '下载模板',
                            type: 'default',
                            source: {
                                apiPath: '/templates/UNION_CATEGORY_BY_SKU',
                            },
                            span: 2,
                            style: { marginBottom: '20px', marginLeft: '-0.6vw' },
                        },
                        {
                            component: 'Button',
                            text: '查询',
                            type: 'default',
                            span: 2,
                            style: { marginBottom: '20px', marginLeft: '-0.2vw' },
                            onClick: this.getValue,
                        },
                    ],
                };
                break;
        }
        if (layoutProps) {
            return createElement(ComponentsManager.get('GridLayout'), layoutProps);
        } else {
            return '';
        }
    }

    renderTable() {
        const {
            entities: { categoryUnionProduct },
            componentId,
        } = this.props;
        const { refresh } = this.state;
        const { currentType } = this.state;
        let columns;
        let rowSelection;
        let actionColumnItems = [
            {
                text: '删除',
                type: 'delete',
                config: {
                    type: 'link',
                    tooltip: null,
                    title: '确定删除该关联吗?',
                    okText: '确定',
                    cancelText: '取消',
                },
            },
        ];
        switch (currentType) {
            case 'ATTR':
                columns = [
                    {
                        property: 'attrName',
                    },
                    {
                        property: 'attrValues',
                    },
                ];
                // if (refresh === 'false') {
                //     actionColumnItems = [];
                // }
                break;
            case 'PRODUCT':
                columns = [
                    {
                        property: 'productName',
                    },
                    {
                        property: 'skuCode',
                    },
                ];
                rowSelection = {
                    onChange() {},
                };
                break;
        }
        const tableProps = {
            entity: categoryUnionProduct,
            componentId,
            rowKey: 'id',
            // loadFirstPage: true,
            rowSelection: rowSelection,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns,
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: actionColumnItems,
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        const { currentType } = this.state;
        return (
            <Fragment>
                {this.renderForm()}
                {!isNull(currentType) ? (
                    <Fragment>
                        {this.renderControllers()}
                        {this.renderTable()}
                    </Fragment>
                ) : null}
            </Fragment>
        );
    }
}

function mapStateTopProps(state: any, props: any) {
    const { componentId } = props;
    const component = state.components[componentId];
    const componentState = {
        selectedRowKeys: get(component, 'selectedRowKeys'),
    };
    return componentState;
}

export const CategoryUnionProductTable = connect(mapStateTopProps)(categoryUnionProductTable);
